// Config module - reads from process.env which Vite's `define` injects at build time.
// For server-side usage (web/index.ts, web/src/html.ts), config.js is used instead.

const config: Record<string, any> = {
  MINIMUM_VERSION: process.env.MINIMUM_VERSION,
  IGNORE_MINIMUM_VERSION: process.env.IGNORE_MINIMUM_VERSION,
  WEBPACK_WEB_PORT: process.env.WEBPACK_WEB_PORT,
  WEBPACK_ELECTRON_PORT: process.env.WEBPACK_ELECTRON_PORT,
  WEB_SERVER_PORT: process.env.WEB_SERVER_PORT,
  LBRY_WEB_API: process.env.LBRY_WEB_API,
  LBRY_WEB_API_NO_CF: process.env.LBRY_WEB_API_NO_CF,
  LBRY_WEB_PUBLISH_API: process.env.LBRY_WEB_PUBLISH_API,
  LBRY_WEB_PUBLISH_API_V2: process.env.LBRY_WEB_PUBLISH_API_V2,
  LBRY_WEB_PUBLISH_API_V3: process.env.LBRY_WEB_PUBLISH_API_V3,
  LBRY_WEB_PUBLISH_API_V4: process.env.LBRY_WEB_PUBLISH_API_V4,
  LBRY_API_URL: process.env.LBRY_API_URL,
  LBRY_WEB_BUFFER_API: process.env.LBRY_WEB_BUFFER_API,
  SEARCH_SERVER_API: process.env.SEARCH_SERVER_API,
  SEARCH_SERVER_API_ALT: process.env.SEARCH_SERVER_API_ALT,
  COMMENT_SERVER_API: process.env.COMMENT_SERVER_API,
  LIVESTREAM_SERVER_API: process.env.LIVESTREAM_SERVER_API,
  LIVESTREAM_INGEST_HOST: process.env.LIVESTREAM_INGEST_HOST,
  LIVESTREAM_WEBRTC_PORT: process.env.LIVESTREAM_WEBRTC_PORT,
  LIVESTREAM_WHIP_URL_TEMPLATE: process.env.LIVESTREAM_WHIP_URL_TEMPLATE,
  SHORT_URL_API: process.env.SHORT_URL_API,
  SOCKETY_SERVER_API: process.env.SOCKETY_SERVER_API,
  LOCALE_API: process.env.LOCALE_API,
  GEO_BLOCK_API: process.env.GEO_BLOCK_API,
  WELCOME_VERSION: process.env.WELCOME_VERSION,
  DOMAIN: process.env.DOMAIN,
  SHARE_DOMAIN_URL: process.env.SHARE_DOMAIN_URL,
  URL: process.env.URL,
  RECSYS_ENDPOINT: process.env.RECSYS_ENDPOINT,
  RECSYS_FYP_ENDPOINT: process.env.RECSYS_FYP_ENDPOINT,
  IMAGE_PROXY_URL: process.env.IMAGE_PROXY_URL,
  THUMBNAIL_CDN_URL: process.env.THUMBNAIL_CDN_URL,
  THUMBNAIL_CARDS_CDN_URL: process.env.THUMBNAIL_CARDS_CDN_URL,
  THUMBNAIL_HEIGHT: process.env.THUMBNAIL_HEIGHT,
  THUMBNAIL_HEIGHT_POSTER: process.env.THUMBNAIL_HEIGHT_POSTER,
  THUMBNAIL_WIDTH: process.env.THUMBNAIL_WIDTH,
  THUMBNAIL_WIDTH_POSTER: process.env.THUMBNAIL_WIDTH_POSTER,
  THUMBNAIL_QUALITY: process.env.THUMBNAIL_QUALITY,
  THUMBNAIL_CDN_SIZE_LIMIT_BYTES: process.env.THUMBNAIL_CDN_SIZE_LIMIT_BYTES,
  PLAYER_SERVER: process.env.PLAYER_SERVER,
  SITE_TITLE: process.env.SITE_TITLE,
  SITE_NAME: process.env.SITE_NAME,
  SITE_DESCRIPTION: process.env.SITE_DESCRIPTION,
  SITE_HELP_EMAIL: process.env.SITE_HELP_EMAIL,
  TWITTER_ACCOUNT: process.env.TWITTER_ACCOUNT,
  LOGO_TITLE: process.env.LOGO_TITLE,
  LOGO: process.env.LOGO,
  LOGO_WHITE_TEXT: process.env.LOGO_WHITE_TEXT,
  LOGO_DARK_TEXT: process.env.LOGO_DARK_TEXT,
  AVATAR_DEFAULT: process.env.AVATAR_DEFAULT,
  MISSING_THUMB_DEFAULT: process.env.MISSING_THUMB_DEFAULT,
  OG_TITLE_SUFFIX: process.env.OG_TITLE_SUFFIX,
  OG_HOMEPAGE_TITLE: process.env.OG_HOMEPAGE_TITLE,
  OG_IMAGE_URL: process.env.OG_IMAGE_URL,
  YRBL_HAPPY_IMG_URL: process.env.YRBL_HAPPY_IMG_URL,
  YRBL_SAD_IMG_URL: process.env.YRBL_SAD_IMG_URL,
  LOGIN_IMG_URL: process.env.LOGIN_IMG_URL,
  SITE_CANONICAL_URL: process.env.SITE_CANONICAL_URL,
  DEFAULT_LANGUAGE: process.env.DEFAULT_LANGUAGE,
  AUTO_FOLLOW_CHANNELS: process.env.AUTO_FOLLOW_CHANNELS,
  UNSYNCED_SETTINGS: process.env.UNSYNCED_SETTINGS,
  FARCASTER_ACCOUNT_ASSOC_HEADER: process.env.FARCASTER_ACCOUNT_ASSOC_HEADER,
  FARCASTER_ACCOUNT_ASSOC_PAYLOAD: process.env.FARCASTER_ACCOUNT_ASSOC_PAYLOAD,
  FARCASTER_ACCOUNT_ASSOC_SIGNATURE: process.env.FARCASTER_ACCOUNT_ASSOC_SIGNATURE,
  FARCASTER_ICON_URL: process.env.FARCASTER_ICON_URL,
  FARCASTER_SPLASH_IMAGE_URL: process.env.FARCASTER_SPLASH_IMAGE_URL,
  FARCASTER_SPLASH_BACKGROUND_COLOR: process.env.FARCASTER_SPLASH_BACKGROUND_COLOR,
  FARCASTER_HERO_IMAGE_URL: process.env.FARCASTER_HERO_IMAGE_URL,
  ENABLE_COMMENT_REACTIONS: process.env.ENABLE_COMMENT_REACTIONS === 'true',
  ENABLE_FILE_REACTIONS: process.env.ENABLE_FILE_REACTIONS === 'true',
  ENABLE_CREATOR_REACTIONS: process.env.ENABLE_CREATOR_REACTIONS === 'true',
  ENABLE_NO_SOURCE_CLAIMS: process.env.ENABLE_NO_SOURCE_CLAIMS === 'true',
  ENABLE_PREROLL_ADS: process.env.ENABLE_PREROLL_ADS === 'true',
  CHANNEL_STAKED_LEVEL_VIDEO_COMMENTS: process.env.CHANNEL_STAKED_LEVEL_VIDEO_COMMENTS,
  CHANNEL_CREATION_LIMIT: process.env.CHANNEL_CREATION_LIMIT,
  WEB_PUBLISH_SIZE_LIMIT_GB: process.env.WEB_PUBLISH_SIZE_LIMIT_GB,
  LOADING_BAR_COLOR: process.env.LOADING_BAR_COLOR,

  SHOW_ADS: process.env.SHOW_ADS === 'true',
  KNOWN_APP_DOMAINS: process.env.KNOWN_APP_DOMAINS
    ? process.env.KNOWN_APP_DOMAINS.split(',')
    : ['open.lbry.com', 'lbry.tv', 'lbry.lat', 'odysee.com', 'localhost'],
  STRIPE_PUBLIC_KEY: process.env.STRIPE_PUBLIC_KEY,
  ENABLE_UI_NOTIFICATIONS: process.env.ENABLE_UI_NOTIFICATIONS === 'true',
  ENABLE_MATURE: process.env.ENABLE_MATURE === 'true',
  CUSTOM_HOMEPAGE: process.env.CUSTOM_HOMEPAGE === 'true',
  SHOW_TAGS_INTRO: process.env.SHOW_TAGS_INTRO === 'true',
  LIGHTHOUSE_DEFAULT_TYPES: process.env.LIGHTHOUSE_DEFAULT_TYPES,
  BRANDED_SITE: process.env.BRANDED_SITE,
  ENABLE_STRIPE: process.env.ENABLE_STRIPE,
  ENABLE_ARCONNECT: process.env.ENABLE_ARCONNECT,
  ENABLE_STABLECOIN: process.env.ENABLE_STABLECOIN,
  FIREBASE_API_KEY: process.env.FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: process.env.FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: process.env.FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: process.env.FIREBASE_MEASUREMENT_ID,
  FIREBASE_VAPID_KEY: process.env.FIREBASE_VAPID_KEY,
  AD_KEYWORD_BLOCKLIST: process.env.AD_KEYWORD_BLOCKLIST,
  AD_KEYWORD_BLOCKLIST_CHECK_DESCRIPTION: process.env.AD_KEYWORD_BLOCKLIST_CHECK_DESCRIPTION,
  COMMIT_ID: process.env.COMMIT_ID,
  NODE_ENV: process.env.NODE_ENV,
  DYNAMIC_ROUTES_FIRST: process.env.DYNAMIC_ROUTES_FIRST === 'true',
};

config.SDK_API_PATH = `${config.LBRY_WEB_API}/api/v1`;
config.PROXY_URL = `${config.SDK_API_PATH}/proxy`;
config.PROXY_URL_NO_CF = `${config.LBRY_WEB_API_NO_CF}/api/v1/proxy`;
config.URL_DEV = `http://localhost:${config.WEBPACK_WEB_PORT}`;
config.URL_LOCAL = `http://localhost:${config.WEB_SERVER_PORT}`;
config.FAVICON = `/public/favicon_128.png`;
config.FAVICON_NOTIFICATION = `/public/favicon_notification_128.png`;

export default config;

// Named exports for destructuring imports
export const {
  MINIMUM_VERSION,
  IGNORE_MINIMUM_VERSION,
  WEBPACK_WEB_PORT,
  WEBPACK_ELECTRON_PORT,
  WEB_SERVER_PORT,
  LBRY_WEB_API,
  LBRY_WEB_API_NO_CF,
  LBRY_WEB_PUBLISH_API,
  LBRY_WEB_PUBLISH_API_V2,
  LBRY_WEB_PUBLISH_API_V3,
  LBRY_WEB_PUBLISH_API_V4,
  LBRY_API_URL,
  LBRY_WEB_BUFFER_API,
  SEARCH_SERVER_API,
  SEARCH_SERVER_API_ALT,
  COMMENT_SERVER_API,
  LIVESTREAM_SERVER_API,
  LIVESTREAM_INGEST_HOST,
  LIVESTREAM_WEBRTC_PORT,
  LIVESTREAM_WHIP_URL_TEMPLATE,
  SHORT_URL_API,
  SOCKETY_SERVER_API,
  LOCALE_API,
  GEO_BLOCK_API,
  WELCOME_VERSION,
  DOMAIN,
  SHARE_DOMAIN_URL,
  URL,
  RECSYS_ENDPOINT,
  RECSYS_FYP_ENDPOINT,
  IMAGE_PROXY_URL,
  THUMBNAIL_CDN_URL,
  THUMBNAIL_CARDS_CDN_URL,
  THUMBNAIL_HEIGHT,
  THUMBNAIL_HEIGHT_POSTER,
  THUMBNAIL_WIDTH,
  THUMBNAIL_WIDTH_POSTER,
  THUMBNAIL_QUALITY,
  THUMBNAIL_CDN_SIZE_LIMIT_BYTES,
  PLAYER_SERVER,
  SITE_TITLE,
  SITE_NAME,
  SITE_DESCRIPTION,
  SITE_HELP_EMAIL,
  TWITTER_ACCOUNT,
  LOGO_TITLE,
  LOGO,
  LOGO_WHITE_TEXT,
  LOGO_DARK_TEXT,
  AVATAR_DEFAULT,
  MISSING_THUMB_DEFAULT,
  OG_TITLE_SUFFIX,
  OG_HOMEPAGE_TITLE,
  OG_IMAGE_URL,
  YRBL_HAPPY_IMG_URL,
  YRBL_SAD_IMG_URL,
  LOGIN_IMG_URL,
  SITE_CANONICAL_URL,
  DEFAULT_LANGUAGE,
  AUTO_FOLLOW_CHANNELS,
  UNSYNCED_SETTINGS,
  ENABLE_COMMENT_REACTIONS,
  ENABLE_FILE_REACTIONS,
  ENABLE_CREATOR_REACTIONS,
  ENABLE_NO_SOURCE_CLAIMS,
  ENABLE_PREROLL_ADS,
  CHANNEL_STAKED_LEVEL_VIDEO_COMMENTS,
  CHANNEL_CREATION_LIMIT,
  WEB_PUBLISH_SIZE_LIMIT_GB,
  LOADING_BAR_COLOR,

  SHOW_ADS,
  KNOWN_APP_DOMAINS,
  STRIPE_PUBLIC_KEY,
  ENABLE_UI_NOTIFICATIONS,
  ENABLE_MATURE,
  CUSTOM_HOMEPAGE,
  SHOW_TAGS_INTRO,
  LIGHTHOUSE_DEFAULT_TYPES,
  BRANDED_SITE,
  ENABLE_STRIPE,
  ENABLE_ARCONNECT,
  ENABLE_STABLECOIN,
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
  FIREBASE_VAPID_KEY,
  AD_KEYWORD_BLOCKLIST,
  AD_KEYWORD_BLOCKLIST_CHECK_DESCRIPTION,
  COMMIT_ID,
  NODE_ENV,
  DYNAMIC_ROUTES_FIRST,
  SDK_API_PATH,
  PROXY_URL,
  PROXY_URL_NO_CF,
  URL_DEV,
  URL_LOCAL,
  FAVICON,
  FAVICON_NOTIFICATION,
  FARCASTER_ACCOUNT_ASSOC_HEADER,
  FARCASTER_ACCOUNT_ASSOC_PAYLOAD,
  FARCASTER_ACCOUNT_ASSOC_SIGNATURE,
  FARCASTER_ICON_URL,
  FARCASTER_SPLASH_IMAGE_URL,
  FARCASTER_SPLASH_BACKGROUND_COLOR,
  FARCASTER_HERO_IMAGE_URL,
} = config;
